import React from 'react';
//UI
import { IonContent } from '@ionic/react';

const LeadAppView: React.FC = () => {
	return <IonContent></IonContent>;
};

export default LeadAppView;
